module.exports = __webpack_public_path__ + "static/img/activity2_1.78bb48b3.png";